// stripe.js
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  "pk_test_51PVbD1Ay4vwOMCaxqAZvVR6g4TXsVnFZWUd0FAKlfUkUPGiDoHbY0C3YJc3bTrl25g1UJCDGM13paPQ0AvzfXWQn00FYJQ3pmW"
); // Replace with your publishable key

export { stripePromise };
